import {type GameState, type NestedPartial, type NestedReadonly} from '@colonist/game-states'
import {applyDiffs} from '@colonist/game-state-types'

export class UIGameState {
    private readonly state: NestedReadonly<GameState>

    constructor(state: NestedReadonly<GameState>) {
        this.state = state
    }

    applyStateUpdates(stateUpdate: NestedPartial<GameState>[]) {
        applyDiffs(this.state, stateUpdate)
    }
}
